var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdidas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302 204.27155",
    height: 204.27,
    width: 302,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.955 0 0 -21.955 -2043.1 10481)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.72 468.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.639 0-1.018 0.327-1.047 0.798h0.611c0-0.157 0.087-0.366 0.465-0.379 0.262 0 0.407 0.157 0.407 0.275-0.029 0.183-0.262 0.196-0.494 0.236-0.262 0.038-0.465 0.091-0.611 0.156-0.203 0.105-0.32 0.328-0.32 0.563 0 0.419 0.35 0.746 0.96 0.746 0.582 0 0.96-0.301 0.988-0.759h-0.581c0 0.117-0.029 0.314-0.378 0.314-0.233 0-0.378-0.039-0.407-0.209 0-0.236 0.494-0.223 0.872-0.314 0.349-0.092 0.582-0.314 0.582-0.629 0-0.576-0.465-0.798-1.047-0.798"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.955 0 0 -21.955 33.537 118.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.006 1.165 1.076-1.846h-2.704"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.955 0 0 -21.955 126.15 202.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v2.33",
    stroke: "#000",
    strokeWidth: 0.587
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.955 0 0 -21.955 -2043.1 10481)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.655 469.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-0.366 0.32-0.667 0.668-0.667 0.379 0 0.669 0.301 0.669 0.667 0 0.353-0.29 0.667-0.669 0.667-0.348 0-0.668-0.314-0.668-0.667m0.639-1.204c-0.639 0-1.191 0.537-1.191 1.204s0.552 1.191 1.191 1.191c0.262 0 0.495-0.066 0.698-0.209v0.183h0.582v-2.316h-0.582v0.144c-0.174-0.131-0.436-0.197-0.698-0.197"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.955 0 0 -21.955 197.59 133.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.791 4.868 2.006 1.178 3.489-6.046"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.955 0 0 -21.955 -2043.1 10481)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.33 469.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-0.366 0.291-0.667 0.669-0.667 0.348 0 0.669 0.301 0.669 0.667 0 0.353-0.321 0.667-0.669 0.667-0.378 0-0.669-0.314-0.669-0.667m0.64-1.204c-0.669 0-1.192 0.537-1.192 1.204s0.523 1.191 1.192 1.191c0.261 0 0.494-0.066 0.698-0.209v0.981h0.581v-3.114h-0.581v0.144c-0.204-0.131-0.437-0.197-0.698-0.197"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.955 0 0 -21.955 85.247 73.119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.035 1.151 2.239-3.912h-2.123v-0.576h-0.581v0.576"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.955 0 0 -21.955 -2043.1 10481)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.39 470.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.146 0-0.291 0.131-0.291 0.288s0.145 0.288 0.291 0.288c0.174 0 0.291-0.131 0.291-0.288s-0.117-0.288-0.291-0.288m0 0.536c-0.146 0-0.233-0.117-0.233-0.248s0.087-0.249 0.233-0.249c0.145 0 0.232 0.118 0.232 0.249s-0.087 0.248-0.232 0.248"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.45 470.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.058 0.131h-0.058v-0.131h-0.044v0.314h0.131c0.029 0 0.087-0.04 0.087-0.092s-0.029-0.078-0.058-0.091l0.058-0.131m-0.116 0.274h-0.058v-0.104h0.058c0.058 0 0.058 0.013 0.058 0.052 0 0.027 0 0.052-0.058 0.052"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.55 469.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-0.366 0.291-0.667 0.669-0.667 0.349 0 0.668 0.301 0.668 0.667 0 0.353-0.319 0.667-0.668 0.667-0.378 0-0.669-0.314-0.669-0.667m0.639-1.204c-0.668 0-1.191 0.537-1.191 1.204s0.523 1.191 1.191 1.191c0.262 0 0.495-0.066 0.698-0.209v0.183h0.553v-2.316h-0.553v0.144c-0.203-0.131-0.436-0.197-0.698-0.197"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.877 469.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-0.366 0.32-0.667 0.669-0.667 0.378 0 0.669 0.301 0.669 0.667 0 0.353-0.291 0.667-0.669 0.667-0.349 0-0.669-0.314-0.669-0.667m1.338 1.963h0.581v-3.114h-0.581v0.144c-0.175-0.131-0.408-0.197-0.669-0.197-0.669 0-1.221 0.537-1.221 1.204s0.552 1.191 1.221 1.191c0.261 0 0.494-0.066 0.669-0.209v0.981z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdidas);
export default __webpack_public_path__ + "static/media/adidas.52d254e1e815b61895c5ca1de07b3f66.svg";
export { ForwardRef as ReactComponent };